@if (!field.hidden) {
  <ng-container [formGroup]="form">
    @if (field.forOfficeUseOnly) {
      <div class="office-text">{{ 'FRONTEND.STORE.ORDER_FORM.HIDDEN_FROM_END_USERS' | translate }}:</div>
    }
    @if (field.officeEditableOnly) {
      <div class="office-text">{{ 'FRONTEND.STORE.ORDER_FORM.OFFICE_EDITABLE_ONLY' | translate }}:</div>
    }
    @switch (field.controlType) {
      @case ('dropdown') {
        @if (!field.allowMultiples) {
          <div class="display">
            <glxy-form-field>
              <glxy-label>{{ field.label | translate }}{{ field.required ? '*' : '' }}</glxy-label>
              <mat-select matInput [formControlName]="field.id" [id]="field.id">
                @for (option of field.options; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
              @if (field.description) {
                <glxy-hint position="below">
                  {{ field.description }}
                </glxy-hint>
              }
            </glxy-form-field>
          </div>
          <div class="print">
            <div class="label">{{ field.label | translate }}:</div>
            <div class="answer">{{ dropdownAnswer() }}</div>
          </div>
        }
        @if (field.allowMultiples) {
          <div class="display">
            <forms-input-tags
              [id]="field.id"
              [formControlName]="field.id"
              label="{{ field.label | translate }}{{ field.required ? ' *' : '' }}"
              [hint]="field.description"
              [required]="field.required"
              [options]="field.options"
              [allowDuplicates]="field.allowDuplicates"
              [maxFields]="field.maxChoices"
            ></forms-input-tags>
          </div>
          <div class="print">
            <div class="label">{{ field.label | translate }}:</div>
            <div class="answer">{{ multidropdownAnswer() }}</div>
          </div>
        }
      }

      @case ('textbox') {
        <div class="display">
          <glxy-form-field [prefixText]="field.prefix" [suffixText]="field.suffix">
            <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
            <input
              matInput
              [type]="field.textboxType"
              [id]="field.id"
              [formControlName]="field.id"
              [pattern]="field.regexValidator || ''"
              [readonly]="field.displayOnly"
              [ngClass]="{ 'display-only': field.displayOnly }"
            />
            @if (field.description) {
              <glxy-hint position="below">
                {{ field.description }}
              </glxy-hint>
            }
            @if (form.controls[field.id].hasError('pattern')) {
              <glxy-error>
                {{ field.regexErrorMessage }}
              </glxy-error>
            }
          </glxy-form-field>
        </div>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer">{{ getValue() }}</div>
        </div>
      }

      @case ('checkbox') {
        <div class="display">
          <glxy-form-field>
            <mat-checkbox [formControlName]="field.id" [id]="field.id" ngControlDefault>
              <span [innerHTML]="field.label | sanitizeCheckboxLabel: field.required"></span>
              @if (field.description) {
                <extended>
                  {{ field.description }}
                </extended>
              }
            </mat-checkbox>
            @if (showCheckboxError(field.id)) {
              <glxy-error class="checkboxError">
                {{ 'FRONTEND.STORE.REQUIRED' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        </div>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer">{{ checkboxAnswer() }}</div>
        </div>
      }

      @case ('textarea') {
        <span class="display">
          <glxy-form-field>
            <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
            <textarea matInput [formControlName]="field.id" [id]="field.id" cdkTextareaAutosize></textarea>
            @if (field.description) {
              <glxy-hint position="below">
                {{ field.description }}
              </glxy-hint>
            }
          </glxy-form-field>
        </span>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer textarea-answer">{{ getValue() }}</div>
        </div>
      }

      @case ('file') {
        @if (this.form.controls[this.field.id].value; as uploadedFiles) {
          <span class="display">
            <glxy-form-field
              [required]="field.required"
              [forceRequiredError]="
                this.form.controls[this.field.id].touched && (!uploadedFiles.length || uploadedFiles?.length === 0)
              "
            >
              <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
              @if (field.description) {
                <glxy-hint position="below">
                  {{ field.description }}
                </glxy-hint>
              }
              @if (!field.disabled) {
                <glxy-uploader
                  #glxyUploader
                  [uploadUrl]="field.uploadUrl"
                  [maxFiles]="field.numFiles"
                  [maxFileSize]="MAX_FILE_SIZE"
                  (fileUploaded)="onUpload($event)"
                  [hasError]="
                    this.form.controls[this.field.id].touched &&
                    (!uploadedFiles.length || uploadedFiles?.length === 0) &&
                    field.required
                  "
                ></glxy-uploader>
                <glxy-uploader-list
                  [files]="uploadedFiles || []"
                  (fileDeleted)="deleteFile($event)"
                ></glxy-uploader-list>
              }
              @if (field.disabled) {
                @if (!uploadedFiles.length) {
                  &mdash;
                }
                @if (uploadedFiles.length) {
                  <ul class="file-static-list">
                    @for (file of uploadedFiles; track file) {
                      <li>
                        <a href="{{ file.url }}" target="_blank">{{ file.name }}</a>
                      </li>
                    }
                  </ul>
                }
              }
            </glxy-form-field>
          </span>
          <div class="print">
            <div class="label">{{ field.label | translate }}:</div>
            <div class="answer">{{ fileUploadAnswer() }}</div>
          </div>
        }
      }

      @case ('vbcuser') {
        <div class="display">
          <glxy-form-field>
            <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
            <mat-select matInput [formControlName]="field.id" [id]="field.id">
              @for (option of field.options; track option) {
                <mat-option [value]="option.value" [disabled]="option.disabled">
                  {{ option.label | translate }}
                </mat-option>
              }
            </mat-select>
            @if (field.description) {
              <glxy-hint position="below">
                {{ field.description }}
              </glxy-hint>
            }
          </glxy-form-field>
        </div>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer">{{ dropdownAnswer() }}</div>
        </div>
      }
    }
  </ng-container>
}
